import { render, staticRenderFns } from "./QuestionImage.vue?vue&type=template&id=2f78c5f2&scoped=true&lang=pug&"
import script from "./QuestionImage.vue?vue&type=script&lang=ts&"
export * from "./QuestionImage.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionImage.vue?vue&type=style&index=0&id=2f78c5f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78c5f2",
  null
  
)

export default component.exports